import React from "react"
import { EditBandFormField } from "./EditBandFormField"
import { Band } from "../../types/bands"

interface BacklineOfferingsProps {
  band: Band
}

export const BacklineOfferings: React.FC<BacklineOfferingsProps> = ({
  band,
}) => {

  const MARKDOWN_GUIDE_URL = "https://www.markdownguide.org/cheat-sheet/"

  const notes = (
    <span>
      You can use{" "}
      <a
        className="text-blue-500"
        target="_blank"
        href={MARKDOWN_GUIDE_URL}
        rel="noreferrer"
      >
        markdown
      </a>{" "}
      if you like here ;)
    </span>
  )

  const fieldData = {
    field: "backline_offerings",
    name: "backlineOfferings",
    label: "Backline Offerings",
    placeholder:
      "Describe what backline equipment you provide (e.g., drums, amps, PA system, etc.)",
    required: false,
    notes: notes,
  }

  return <EditBandFormField type="textarea" fieldData={fieldData} />
}
